/* globals jQuery */
//https://swiperjs.com/
import Swiper, { Navigation, Pagination, Keyboard, A11y } from 'swiper'; // import Swiper bundle with all modules installed

(($) => {

    // configure Swiper to use modules
    Swiper.use([Navigation, Pagination, Keyboard, A11y]);

    const swipers = document.querySelectorAll('.swiper');
    const swiperPrev = document.querySelectorAll('.swiper-button-prev');
    const swiperNext = document.querySelectorAll('.swiper-button-next');

    swipers.forEach((slider, index) => {

        if (slider.classList.contains('js-swiper-slideshow-cta')) {

            const swiper_cta_slideshow = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 1000,
                loop: false,
                keyboard: {
                    enabled: true
                },
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					hideOnclick: false,
					clickable: true
				},
                navigation: {
                    prevEl: swiperPrev[index],
                    nextEl: swiperNext[index]
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous slide',
                    nextSlideMessage: 'Next slide',
                },
            });
        }

    });

})(jQuery)
